module.exports = __webpack_public_path__ + "img/160394.3b08df66.png";